import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "../../../../components/TableContainer";
import Page from "../../../../components/Layout/Page";
import { useIsMobile } from "../../../../helpers/ui";
import { DesktopHeader, MobileHeader } from "../Account/components";
import { employeeAccountPath } from "../../../../routes/paths";
import HeaderBreadcrumbs from "../../../../components/HeaderBreadcrumbs";
import ResponsePageContent from "../../../../components/Layout/ResponsivePageContent";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader";
import ErrorPage from "../../../../components/ErrorPage";
import useGetTransactions from "../../../../hooks/queries/employee/useGetTransactions";
import Transaction from "../../../../components/Transaction";

export const calculatePotentialSavings = (
  contributionsSoFar: number,
  contribution: number,
  monthsLeftInProgram: number
) => {
  return contributionsSoFar + contribution * monthsLeftInProgram;
};

const Transactions = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { data, status } = useGetTransactions({ page: page + 1 });

  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const title = "Transactions";
  const subtitle = "Your deposits, withdrawals, and matches";
  const breadcrumbs = ["My Account", title];

  if (status === "loading") return <Loader />;
  if (status === "error") return <ErrorPage />;

  const doBack = () => {
    navigate(employeeAccountPath);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  return (
    <Page>
      {isMobile ? (
        <MobileHeader
          title={title}
          showBack
          showClose
          handleBack={doBack}
          closeRoutePath={employeeAccountPath}
        />
      ) : (
        <DesktopHeader>
          <HeaderBreadcrumbs breadcrumbs={breadcrumbs} handleBack={doBack} />
        </DesktopHeader>
      )}
      <ResponsePageContent title={title} subtitle={subtitle}>
        <div className="w-100 mt-16" style={{ marginBottom: "128px" }}>
          <TableContainer title="" containerComponent={"div"} noBorder>
            <Table aria-label="table header">
              <TableBody>
                {data.results.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <Transaction transaction={row} showBorder={false} />
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[25]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) =>
                setRowsPerPage(e.target.value as unknown as number)
              }
              count={data.count}
              page={page}
              onPageChange={handleChangePage}
              component="div"
              sx={{ background: "#f9fafb" }}
            />
          </TableContainer>
        </div>
      </ResponsePageContent>
    </Page>
  );
};

export default Transactions;
